export default "__VITE_ASSET__d86356f4__"